import { render, staticRenderFns } from "./side-bar.vue?vue&type=template&id=f22629d8&scoped=true&"
import script from "./side-bar.vue?vue&type=script&lang=ts&"
export * from "./side-bar.vue?vue&type=script&lang=ts&"
import style0 from "./side-bar.vue?vue&type=style&index=0&id=f22629d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22629d8",
  null
  
)

export default component.exports